import { useEffect } from "react";
import { api } from "./api";
import { createStore } from "./store";
export interface Person { user_id: string; name: string; field: string | null; expires_in_ms: number; until: number }
export interface PresenceSnapshot { loan_id: string; people: Omit<Person, "until">[] }
export const presenceStore = createStore<Map<string, Person[]>>(new Map());
let target: { loan_id: string; field?: string } | null = null;
let lastSent = 0;
export function setPresenceTarget(loanId: string | null, field?: string) { target = loanId ? { loan_id: loanId, field } : null; }
export function resetPresence() { target = null; presenceStore.set(new Map()); }
export function acceptPresence(snapshot: PresenceSnapshot, now = Date.now()) {
  presenceStore.set((old) => { const next = new Map(old); next.set(snapshot.loan_id, snapshot.people.map((p) => ({ ...p, until: now + Math.min(30_000, Math.max(0, p.expires_in_ms)) }))); return next; });
}
export function expirePresence(now = Date.now()) {
  const old = presenceStore.get();
  const next = new Map<string, Person[]>();
  for (const [id, people] of old) { const alive = people.filter((p) => p.until > now); if (alive.length) next.set(id, alive); }
  if (next.size !== old.size || [...next].some(([id, p]) => p.length !== old.get(id)?.length)) presenceStore.set(next);
}
export function usePresenceClient(userId: string) {
  useEffect(() => {
    presenceStore.set(new Map());
    let stopped = false;
    const tick = () => {
      expirePresence();
      if (target && Date.now() - lastSent >= 5100) {
        lastSent = Date.now();
        void api("/api/presence", { method: "PUT", body: target }).catch(() => undefined);
      }
    };
    const controller = new AbortController();
    void api<PresenceSnapshot[]>("/api/presence", { signal: controller.signal }).then((snapshots) => { if (!stopped) snapshots.forEach((s) => acceptPresence(s)); }).catch(() => undefined);
    const timer = window.setInterval(tick, 1000);
    return () => { stopped = true; controller.abort(); window.clearInterval(timer); resetPresence(); };
  }, [userId]);
}
